import { post } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main";

const state = {
  isLoadingData: false,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  users: [],
};

const mutations = {
  SET_LOADING(state, value) {
    state.isLoadingData = value;
  },
  SET_BTN_LOADING(state, value) {
    state.isBtnLoading = value;
  },
  SET_BTN_EDIT_LOADING(state, value) {
    state.isBtnEditLoading = value;
  },
  SET_SEARCH(state, value) {
    state.search = value;
  },
  SET_USERS(state, users) {
    state.users = users;
  },
};

const actions = {
  async getUsers({ commit }) {
    try {
      const res = await post("sarmaya/get-users", {}, { id: 46, action: "view" });
      commit("SET_USERS", res.data || []);
      return res;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async getItems({ commit }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await post("sarmaya/index?page=" + payload.page, payload, {
        id: 46,
        action: "view",
      });
      commit("SET_LOADING", false);
      return res;
    } catch (error) {
      commit("SET_LOADING", false);
      console.log(error);
      return error;
    }
  },
  async getSummary(_, payload = {}) {
    try {
      return await post("sarmaya/summary", payload, { id: 46, action: "view" });
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async addItem({ commit }, payload) {
    commit("SET_BTN_LOADING", true);
    try {
      const res = await post("sarmaya/store", payload, { id: 46, action: "add" });
      toast("success", i18n.global.t("added_successfully"));
      commit("SET_BTN_LOADING", false);
      return res;
    } catch (error) {
      commit("SET_BTN_LOADING", false);
      toast("error", i18n.global.t("something_wrong"));
      return error;
    }
  },
  async editItem({ commit }, payload) {
    commit("SET_BTN_EDIT_LOADING", true);
    try {
      const res = await post("sarmaya/edit/" + payload.sat_id, payload, {
        id: 46,
        action: "edit",
      });
      toast("success", i18n.global.t("edited_successfully"));
      commit("SET_BTN_EDIT_LOADING", false);
      return res;
    } catch (error) {
      commit("SET_BTN_EDIT_LOADING", false);
      toast("error", i18n.global.t("something_wrong"));
      return error;
    }
  },
  async deleteItem(_, id) {
    try {
      const res = await post("sarmaya/delete/" + id, {}, { id: 46, action: "delete" });
      toast("success", i18n.global.t("deleted_successfully"));
      return res;
    } catch (error) {
      toast("error", i18n.global.t("something_wrong"));
      return error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
